import { lazy } from 'react';

export const PartnerBirthTimePageLazy = lazy(() => import('./partner-birthtime'));
